import { Component, inject } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { PrivaLoaderComponent } from '@priva/components/loader';
import { PrivaNotificationModule } from '@priva/components/notification';
import { PrivaSpinnerComponent } from '@priva/components/spinner';
import { PrivaLocalizationModule } from '@priva/localization';

import { loadMasterDataFromServer } from 'app/state/master-data/master-data.actions';
import { selectMasterDataStatus } from 'app/state/master-data/master-data.selectors';

@Component({
    selector: 'app-load-master-data',
    templateUrl: './load-master-data.component.html',
    styleUrl: './load-master-data.component.scss',
    imports: [
        LetDirective,
        PrivaSpinnerComponent,
        PrivaLoaderComponent,
        PrivaNotificationModule,
        PrivaSpinnerComponent,
        PrivaLocalizationModule,
    ],
})
export class LoadMasterDataComponent {
    private store = inject(Store);

    loadMasterDataStatus$ = this.store.select(selectMasterDataStatus).pipe(
        map((masterDataStatus) => {
            switch (masterDataStatus) {
                case 'loading':
                case 'missing':
                    return 'in-progress';
                case 'refreshing':
                case 'ready':
                    return 'done';
                case 'error':
                    return 'error';
            }
        }),
    );

    reloadMasterData() {
        this.store.dispatch(loadMasterDataFromServer());
    }
}
